import React from 'react';
import './StatsTicker.css';

const StatsTicker = () => (
  <div className="stats-bar">
    <div className="ticker-wrapper">
      {[0, 1].map((_, i) => (
        <React.Fragment key={i}>
          <div className="stat-item">
            <div className="stat-n">CASH SOL</div>
            <div className="stat-l">PRÉSTAMOS PERSONALES - Evaluación Rápida con DNI</div>
            <span className="stat-sep">|</span>
          </div>
          <div className="stat-item">
            <div className="stat-n">PRÉSTAMOS CON RESPALDO GARANTÍA</div>
            <div className="stat-l">Joyas en Oro 18K - Motos - Electrodomésticos - Electrónicos</div>
            <span className="stat-sep">|</span>
          </div>
        </React.Fragment>
      ))}
    </div>
  </div>
);

export default StatsTicker;
